module.exports = __webpack_public_path__ + "media/images/category/dummy/tops01-8ac7c5e0be51e8178d1fa3aaf2244870.jpg";